export interface AdditionalData {
  weight?: number;
  weightUnit?: string;
  producingCompany?: string;
  formulation?: string;
  enginePower?: number;
}

// Parse additional_data string into JS Object safely

export const parseAdditionalData = (
  rawData: string | object | null,
): AdditionalData => {
  if (!rawData || rawData === 'undefined' || rawData === 'null') return {};
  if (typeof rawData === 'object') return rawData as AdditionalData;

  try {
    return JSON.parse(rawData.replace(/'/g, '"')) as AdditionalData;
  } catch (error) {
    console.error('Error parsing additional_data:', error, rawData);
    return {};
  }
};
